<template>
  <div class="news-detail">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link" style="color: #3498db;">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span class="separator">></span>
        <router-link to="/news">行业资讯</router-link>
        <span class="separator">></span>
        <span class="current">资讯详情</span>
      </div>
    </div>

    <!-- 文章内容 -->
    <main class="article-content">
      <div class="container">
        <article class="news-article">
          <!-- 文章标题 -->
          <header class="article-header">
            <h1 class="article-title">{{ article.title }}</h1>
            <div class="article-meta">
              <span class="category">{{ article.category }}</span>
              <span class="date">{{ article.date }}</span>
              <span class="author">作者：{{ article.author }}</span>
              <span class="views">阅读量：{{ article.views }}</span>
            </div>
          </header>

          <!-- 文章摘要 -->
          <div class="article-summary">
            <p>{{ article.summary }}</p>
          </div>

          <!-- 文章正文 -->
          <div class="article-body">
            <div v-html="article.content"></div>
          </div>

          <!-- 文章标签 -->
          <div class="article-tags">
            <span class="tag" v-for="tag in article.tags" :key="tag">{{ tag }}</span>
          </div>

          <!-- 分享按钮 -->
          <div class="article-share">
            <h4>分享到：</h4>
            <div class="share-buttons">
              <button @click="shareToWechat" class="share-btn wechat">
                <span class="icon">💬</span> 微信
              </button>
              <button @click="shareToWeibo" class="share-btn weibo">
                <span class="icon">📱</span> 微博
              </button>
              <button @click="shareToQQ" class="share-btn qq">
                <span class="icon">🐧</span> QQ
              </button>
              <button @click="copyLink" class="share-btn copy">
                <span class="icon">🔗</span> 复制链接
              </button>
            </div>
          </div>
        </article>

        <!-- 相关文章 -->
        <section class="related-articles">
          <h3>相关文章</h3>
          <div class="related-grid">
            <article 
              v-for="related in relatedArticles" 
              :key="related.id"
              class="related-card"
              @click="viewArticle(related)"
            >
              <div class="related-image">
                <div class="image-placeholder">{{ related.image }}</div>
              </div>
              <div class="related-content">
                <h4>{{ related.title }}</h4>
                <p class="related-summary">{{ related.summary }}</p>
                <div class="related-meta">
                  <span class="related-date">{{ related.date }}</span>
                  <span class="related-category">{{ related.category }}</span>
                </div>
              </div>
            </article>
          </div>
        </section>

        <!-- 评论区 -->
        <section class="comments-section">
          <h3>评论交流</h3>
          
          <!-- 发表评论 -->
          <div class="comment-form">
            <h4>发表评论</h4>
            <form @submit.prevent="submitComment">
              <div class="form-group">
                <label>姓名</label>
                <input type="text" v-model="commentForm.name" placeholder="请输入您的姓名" required>
              </div>
              <div class="form-group">
                <label>邮箱</label>
                <input type="email" v-model="commentForm.email" placeholder="请输入您的邮箱" required>
              </div>
              <div class="form-group">
                <label>评论内容</label>
                <textarea 
                  v-model="commentForm.content" 
                  placeholder="请输入您的评论..." 
                  rows="4"
                  required
                ></textarea>
              </div>
              <button type="submit" class="btn-submit">发表评论</button>
            </form>
          </div>

          <!-- 评论列表 -->
          <div class="comments-list">
            <div v-for="comment in comments" :key="comment.id" class="comment-item">
              <div class="comment-avatar">{{ comment.avatar }}</div>
              <div class="comment-content">
                <div class="comment-header">
                  <span class="comment-name">{{ comment.name }}</span>
                  <span class="comment-date">{{ comment.date }}</span>
                </div>
                <p class="comment-text">{{ comment.content }}</p>
                <div class="comment-actions">
                  <button @click="replyComment(comment)" class="action-btn">回复</button>
                  <button @click="likeComment(comment)" class="action-btn">
                    👍 {{ comment.likes }}
                  </button>
                </div>
                
                <!-- 回复列表 -->
                <div v-if="comment.replies && comment.replies.length > 0" class="replies">
                  <div v-for="reply in comment.replies" :key="reply.id" class="reply-item">
                    <div class="reply-avatar">{{ reply.avatar }}</div>
                    <div class="reply-content">
                      <div class="reply-header">
                        <span class="reply-name">{{ reply.name }}</span>
                        <span class="reply-date">{{ reply.date }}</span>
                      </div>
                      <p class="reply-text">{{ reply.content }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>

    <!-- 底部 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p>📍 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p>📞 电话：15383753755</p>
              <p>📧 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="/">首页</a>
              <a href="/#about">关于我们</a>
              <a href="/#services">服务介绍</a>
              <a href="/#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关注我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon">💬 微信公众号</a>
                <a href="#" class="social-icon">📨 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p>© 2025 北京和合网链科技发展有限公司 版权所有 | 冀ICP备14010297号</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'NewsDetail',
  data() {
    return {
      article: {}, // 初始为空，将由mounted钩子加载
      relatedArticles: [], // 初始为空，将由loadArticle方法动态生成
      commentForm: {
        name: '',
        email: '',
        content: ''
      },
      comments: [
        {
          id: 1,
          name: '李医生',
          avatar: '👨‍⚕️',
          date: '2024-05-21 10:30',
          content: '量子健康技术确实是医疗领域的一个重要突破，我们医院也在关注这方面的发展。文章对技术原理的讲解很清晰，值得学习。',
          likes: 12,
          replies: [
            {
              id: 11,
              name: '王研究员',
              avatar: '👩‍🔬',
              date: '2024-05-21 11:15',
              content: '同意李医生的观点。量子技术在医疗领域的应用前景非常广阔，期待更多的临床验证。'
            }
          ]
        },
        {
          id: 2,
          name: '健康爱好者',
          avatar: '💪',
          date: '2024-05-21 14:20',
          content: '作为普通读者，我觉得这篇文章很有价值。量子健康技术听起来很神奇，希望能尽快普及应用。',
          likes: 8,
          replies: []
        }
      ],
      // 所有文章数据
      allArticles: {
        1: {
          id: 1,
          title: '量子健康技术在医疗领域的最新应用突破',
          category: '技术前沿',
          date: '2024-05-20',
          author: '张明华',
          views: 1523,
          summary: '量子健康技术作为新兴领域，正在医疗行业展现出巨大潜力。最新研究表明，量子检测技术能够更准确地预测健康风险，为早期诊断和预防提供了新的可能性。',
          content: `
            <h2>量子健康技术的发展历程</h2>
            <p>量子健康技术起源于20世纪初的量子物理学研究，经过近百年的发展，已经从理论走向实践。近年来，随着量子计算和量子传感技术的突破，量子健康技术在医疗领域的应用迎来了快速发展期。</p>
            
            <h2>核心技术原理</h2>
            <p>量子健康技术主要基于以下几个核心原理：</p>
            <ul>
              <li><strong>量子纠缠原理：</strong>利用量子纠缠现象，实现对人体内部状态的精确检测</li>
              <li><strong>量子叠加原理：</strong>通过量子叠加态，同时检测多个健康指标</li>
              <li><strong>量子隧穿效应：</strong>利用量子隧穿效应，实现对深层组织的无创检测</li>
            </ul>
            
            <h2>临床应用案例</h2>
            <p>在临床实践中，量子健康技术已经展现出显著优势：</p>
            <h3>1. 早期癌症筛查</h3>
            <p>传统的癌症筛查方法往往需要在肿瘤发展到一定大小才能发现，而量子检测技术可以在细胞层面发现异常，大大提前了诊断时间。临床数据显示，量子检测技术对早期癌症的检出率比传统方法高出40%。</p>
            
            <h3>2. 心血管疾病预测</h3>
            <p>通过量子检测技术，可以实时监测血管内皮功能、血液流变学指标等，为心血管疾病的早期预警提供了新的手段。研究表明，量子技术对心肌梗死的预测准确率达到92%。</p>
            
            <h2>结语</h2>
            <p>量子健康技术正在引领医疗健康领域的革命性变革。随着技术的不断成熟和应用的深入，相信在不久的将来，量子健康技术将成为每个人健康管理的重要工具，为人类健康事业做出更大贡献。</p>
          `,
          tags: ['量子健康', '医疗技术', '早期诊断', '健康管理']
        },
        2: {
          id: 2,
          title: '健康管理行业发展趋势分析',
          category: '行业分析',
          date: '2024-05-15',
          author: '李晓明',
          views: 892,
          summary: '随着人们健康意识的提高，健康管理行业呈现快速发展态势。数字化、智能化成为行业发展的主要趋势。',
          content: `
            <h2>行业发展背景</h2>
            <p>近年来，随着我国经济的快速发展和人民生活水平的提高，人们对健康的需求日益增长。健康管理行业作为大健康产业的重要组成部分，迎来了前所未有的发展机遇。</p>
            
            <h2>市场规模与增长</h2>
            <p>据统计，我国健康管理行业市场规模从2019年的3000亿元增长到2023年的8000亿元，年均增长率超过25%。预计到2025年，市场规模将突破1.2万亿元。</p>
            
            <h2>发展趋势</h2>
            <h3>1. 数字化转型</h3>
            <p>人工智能、大数据、物联网等技术的广泛应用，推动健康管理行业向数字化、智能化方向发展。智能穿戴设备、健康APP等成为人们日常健康管理的重要工具。</p>
            
            <h3>2. 个性化服务</h3>
            <p>基于基因检测、健康评估等技术的个性化健康管理方案越来越受到青睐。千人千面的健康管理模式正在形成。</p>
            
            <h3>3. 预防为主</h3>
            <p>从"治疗为主"向"预防为主"转变，健康管理的重点逐渐前移，更加注重疾病的早期预防和健康风险的干预。</p>
            
            <h2>未来展望</h2>
            <p>健康管理行业未来发展前景广阔，将在技术创新、服务模式、产业链整合等方面持续深化，为人民群众提供更加优质、便捷的健康服务。</p>
          `,
          tags: ['健康管理', '行业趋势', '数字化', '预防医学']
        },
        3: {
          id: 3,
          title: '如何通过科学方式提升免疫力',
          category: '健康科普',
          date: '2024-05-10',
          author: '王健康',
          views: 1256,
          summary: '免疫力是人体抵御疾病的重要防线。本文将介绍几种科学有效的方法来提升和维持良好的免疫力。',
          content: `
            <h2>什么是免疫力</h2>
            <p>免疫力是人体识别和排除异己、保护自身稳定的生理功能。良好的免疫力可以帮助我们抵御各种疾病的侵袭。</p>
            
            <h2>提升免疫力的科学方法</h2>
            
            <h3>1. 均衡营养</h3>
            <p>营养是维持免疫系统正常功能的基础。建议：</p>
            <ul>
              <li>充足的蛋白质：鱼、肉、蛋、奶等</li>
              <li>丰富的维生素C：柑橘、猕猴桃、青椒等</li>
              <li>适量的锌元素：坚果、海产品等</li>
              <li>充足的维生素D：晒太阳、鱼类等</li>
            </ul>
            
            <h3>2. 规律运动</h3>
            <p>适度的运动可以显著提升免疫力：</p>
            <ul>
              <li>每周至少150分钟中等强度运动</li>
              <li>包括有氧运动和力量训练</li>
              <li>避免过度运动，反而会降低免疫力</li>
            </ul>
            
            <h3>3. 充足睡眠</h3>
            <p>睡眠对免疫系统的恢复和调节至关重要：</p>
            <ul>
              <li>成人每天7-9小时睡眠</li>
              <li>保持规律的作息时间</li>
              <li>创造良好的睡眠环境</li>
            </ul>
            
            <h3>4. 压力管理</h3>
            <p>长期压力会抑制免疫系统功能：</p>
            <ul>
              <li>学会放松技巧：深呼吸、冥想等</li>
              <li>培养兴趣爱好</li>
              <li>保持积极乐观的心态</li>
            </ul>
            
            <h2>总结</h2>
            <p>提升免疫力是一个系统工程，需要从营养、运动、睡眠、心理等多个方面综合调理。坚持科学的生活方式，才能建立强大的免疫防线。</p>
          `,
          tags: ['免疫力', '健康科普', '生活方式', '预防保健']
        },
        4: {
          id: 4,
          title: '慢性病管理的最新进展',
          category: '医学进展',
          date: '2024-05-05',
          author: '赵医生',
          views: 743,
          summary: '慢性病管理是现代医学的重要课题，新的管理方法和技术不断涌现，为患者带来更好的生活质量。',
          content: `
            <h2>慢性病管理的重要性</h2>
            <p>随着人口老龄化加剧，慢性病已成为威胁人类健康的主要因素。有效的慢性病管理不仅能改善患者生活质量，还能减少医疗费用支出。</p>
            
            <h2>最新管理进展</h2>
            
            <h3>1. 数字化管理工具</h3>
            <p>移动互联网和智能设备的普及，使慢性病管理更加便捷：</p>
            <ul>
              <li>智能血糖仪实时监测血糖</li>
              <li>血压计自动记录和上传数据</li>
              <li>APP提醒用药和复诊</li>
            </ul>
            
            <h3>2. 个性化治疗方案</h3>
            <p>基于精准医疗的理念，为患者制定个性化治疗方案：</p>
            <ul>
              <li>基因检测指导用药选择</li>
              <li>生活方式干预定制化</li>
              <li>治疗效果实时评估调整</li>
            </ul>
            
            <h3>3. 多学科协作模式</h3>
            <p>建立多学科协作的慢性病管理团队：</p>
            <ul>
              <li>全科医生、专科医生协作</li>
              <li>营养师、运动指导师参与</li>
              <li>心理咨询师支持</li>
            </ul>
            
            <h2>未来发展方向</h2>
            <p>慢性病管理将向着更加智能化、精准化、个性化的方向发展，为患者提供全方位的健康管理服务。</p>
          `,
          tags: ['慢性病', '健康管理', '数字化医疗', '精准医疗']
        },
        5: {
          id: 5,
          title: '冬季健康管理注意事项',
          category: '健康资讯',
          date: '2024-01-05',
          author: '王健康',
          views: 634,
          summary: '专家提醒，冬季是慢性病高发季节，需要特别注意健康管理，合理饮食和适度运动。',
          content: `
            <h2>冬季健康挑战</h2>
            <p>冬季气温低，日照时间短，人体新陈代谢减慢，是各种慢性病的高发季节。科学的健康管理对于维持冬季健康至关重要。</p>
            
            <h2>饮食调理</h2>
            <h3>1. 温补食材</h3>
            <p>冬季应选择温补食材，如：</p>
            <ul>
              <li>根茎类蔬菜：胡萝卜、白萝卜、山药等</li>
              <li>温性水果：苹果、橙子、柿子等</li>
              <li>优质蛋白：鱼肉、鸡肉、豆制品等</li>
              <li>坚果类：核桃、杏仁、腰果等</li>
            </ul>
            
            <h3>2. 饮食禁忌</h3>
            <p>冬季应避免：</p>
            <ul>
              <li>生冷食物，损伤脾胃阳气</li>
              <li>过于油腻，增加消化负担</li>
              <li>辛辣刺激，容易上火</li>
            </ul>
            
            <h2>运动保健</h2>
            <h3>1. 适宜运动</h3>
            <ul>
              <li>室内运动：瑜伽、太极、健身操等</li>
              <li>户外运动：快走、慢跑（注意保暖）</li>
              <li>传统运动：八段锦、五禽戏等</li>
            </ul>
            
            <h3>2. 运动注意事项</h3>
            <ul>
              <li>运动前充分热身</li>
              <li>避免在雾霾天户外运动</li>
              <li>运动后及时更换汗湿衣物</li>
            </ul>
            
            <h2>作息调理</h2>
            <p>冬季应遵循"早睡晚起"的原则：</p>
            <ul>
              <li>晚上10点前入睡</li>
              <li>早上7点后起床</li>
              <li>保证7-8小时充足睡眠</li>
              <li>午休20-30分钟</li>
            </ul>
            
            <h2>疾病预防</h2>
            <h3>1. 呼吸系统疾病</h3>
            <ul>
              <li>注意保暖，避免受凉</li>
              <li>保持室内空气流通</li>
              <li>勤洗手，减少感染机会</li>
            </ul>
            
            <h3>2. 心血管疾病</h3>
            <ul>
              <li>定期监测血压</li>
              <li>避免情绪激动</li>
              <li>控制盐分摄入</li>
            </ul>
            
            <h2>总结</h2>
            <p>冬季健康管理需要从饮食、运动、作息、疾病预防等多个方面综合考虑。只有科学调理，才能健康度过寒冬，为来年的健康打下坚实基础。</p>
          `,
          tags: ['冬季健康', '季节养生', '疾病预防', '生活方式']
        },
        6: {
          id: 6,
          title: '健康产业发展前景分析',
          category: '行业动态',
          date: '2024-01-03',
          author: '李分析师',
          views: 892,
          summary: '随着人口老龄化加剧和健康意识提升，健康产业迎来前所未有的发展机遇。',
          content: `
            <h2>产业发展背景</h2>
            <p>近年来，随着我国经济社会的快速发展和人民生活水平的不断提高，健康产业作为重要的民生工程，迎来了前所未有的发展机遇。人口老龄化、慢性病高发、健康意识提升等多重因素，共同推动着健康产业的快速发展。</p>
            
            <h2>市场规模与增长</h2>
            <h3>1. 整体市场规模</h3>
            <p>据统计数据显示，我国健康产业规模从2015年的3.8万亿元增长到2023年的12.5万亿元，年均增长率超过15%。预计到2025年，市场规模将突破16万亿元。</p>
            
            <h3>2. 细分领域增长</h3>
            <ul>
              <li><strong>医疗服务：</strong>年均增长率12%，预计2025年达到8万亿元</li>
              <li><strong>健康养老：</strong>年均增长率18%，预计2025年达到3.5万亿元</li>
              <li><strong>健康管理：</strong>年均增长率25%，预计2025年达到2万亿元</li>
              <li><strong>医疗器械：</strong>年均增长率20%，预计2025年达到1.5万亿元</li>
            </ul>
            
            <h2>发展驱动力分析</h2>
            <h3>1. 政策支持</h3>
            <p>国家出台了一系列支持健康产业发展的政策文件：</p>
            <ul>
              <li>"健康中国2030"规划纲要</li>
              <li>《关于促进健康服务业发展的若干意见》</li>
              <li>《"十四五"国民健康规划》</li>
            </ul>
            
            <h3>2. 人口结构变化</h3>
            <ul>
              <li>老龄化进程加速：60岁以上人口占比达18.9%</li>
              <li>中产阶级扩大：健康消费能力提升</li>
              <li>城镇化推进：健康服务需求集中</li>
            </ul>
            
            <h3>3. 技术进步</h3>
            <ul>
              <li>人工智能在医疗领域的应用</li>
              <li>基因检测和精准医疗技术</li>
              <li>互联网+医疗健康模式</li>
            </ul>
            
            <h2>重点发展领域</h2>
            <h3>1. 数字健康</h3>
            <p>数字健康成为产业发展的新引擎：</p>
            <ul>
              <li>远程医疗服务</li>
              <li>智能健康管理平台</li>
              <li>医疗大数据应用</li>
            </ul>
            
            <h3>2. 康复护理</h3>
            <p>康复护理服务需求快速增长：</p>
            <ul>
              <li>术后康复服务</li>
              <li>老年护理服务</li>
              <li>慢性病康复管理</li>
            </ul>
            
            <h3>3. 健康管理</h3>
            <p>个性化健康管理服务成为趋势：</p>
            <ul>
              <li>基因检测指导的健康管理</li>
              <li>企业员工健康管理</li>
              <li>社区健康服务</li>
            </ul>
            
            <h2>投资机会与挑战</h2>
            <h3>1. 投资机会</h3>
            <ul>
              <li>互联网医疗平台</li>
              <li>智能医疗器械</li>
              <li>健康养老产业</li>
              <li>健康管理服务</li>
            </ul>
            
            <h3>2. 面临挑战</h3>
            <ul>
              <li>行业标准不统一</li>
              <li>人才短缺问题</li>
              <li>监管政策待完善</li>
              <li>市场竞争加剧</li>
            </ul>
            
            <h2>未来展望</h2>
            <p>健康产业作为朝阳产业，未来发展前景广阔。随着技术的不断进步和政策的持续支持，健康产业将朝着更加智能化、个性化、普惠化的方向发展，为人民群众提供更加优质、便捷的健康服务，为健康中国建设做出更大贡献。</p>
          `,
          tags: ['健康产业', '行业分析', '市场前景', '投资机会']
        }
      }
    }
  },
  methods: {
    shareToWechat() {
      // 微信分享逻辑
      alert('请使用微信扫一扫分享')
    },
    shareToWeibo() {
      // 微博分享逻辑
      const url = window.location.href
      const title = this.article.title
      window.open(`https://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`)
    },
    shareToQQ() {
      // QQ分享逻辑
      const url = window.location.href
      const title = this.article.title
      window.open(`https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`)
    },
    copyLink() {
      // 复制链接逻辑
      const url = window.location.href
      navigator.clipboard.writeText(url).then(() => {
        alert('链接已复制到剪贴板')
      })
    },
    viewArticle(article) {
      // 查看相关文章 - 跳转到对应文章详情页
      this.$router.push({
        path: '/news-detail',
        query: { id: article.id }
      })
    },
    submitComment() {
      // 提交评论
      const newComment = {
        id: Date.now(),
        name: this.commentForm.name,
        avatar: '👤',
        date: new Date().toLocaleString(),
        content: this.commentForm.content,
        likes: 0,
        replies: []
      }
      this.comments.unshift(newComment)
      
      // 重置表单
      this.commentForm = {
        name: '',
        email: '',
        content: ''
      }
      
      alert('评论发表成功！')
    },
    replyComment(comment) {
      // 回复评论
      const replyContent = prompt('请输入回复内容：')
      if (replyContent) {
        const reply = {
          id: Date.now(),
          name: '当前用户',
          avatar: '👤',
          date: new Date().toLocaleString(),
          content: replyContent
        }
        
        if (!comment.replies) {
          comment.replies = []
        }
        comment.replies.push(reply)
      }
    },
    likeComment(comment) {
      // 点赞评论
      comment.likes++
    },
    // 加载指定ID的文章
    loadArticle(articleId) {
      const id = parseInt(articleId) || 1
      if (this.allArticles[id]) {
        this.article = this.allArticles[id]
        // 更新相关文章列表，排除当前文章
        this.relatedArticles = Object.values(this.allArticles)
          .filter(article => article.id !== id)
          .slice(0, 3)
          .map(article => ({
            id: article.id,
            title: article.title,
            summary: article.summary,
            date: article.date,
            category: article.category,
            image: '📰'
          }))
      }
    }
  },
  mounted() {
    // 根据URL参数加载对应文章
    const articleId = this.$route.query.id
    this.loadArticle(articleId)
  },
  watch: {
    // 监听路由变化，更新文章内容
    '$route.query.id'(newId) {
      if(newId){
        this.loadArticle(newId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.news-detail {
  // padding-top: 80px; /* 为fixed导航栏留出空间 */
}

/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar {
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.breadcrumb {
  background: white;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

.breadcrumb .container {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  padding-left: 10px;
  max-width: 100%;
}

.breadcrumb a {
  color: #666;
  text-decoration: none;
}

.breadcrumb a:hover {
  color: #1890ff;
}

.separator {
  color: #999;
}

.current {
  color: #1890ff;
}

/* 通用容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 文章内容 */
.article-content {
  padding: 2rem 0;
  background: white;
  min-height: 100vh;
}

.news-article {
  background: white;
  border-radius: 10px;
  overflow: hidden;
}

/* 文章标题 */
.article-header {
  text-align: center;
  padding: 3rem 2rem 2rem;
  border-bottom: 1px solid #eee;
}

.article-title {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1.5rem;
  line-height: 1.3;
}

.article-meta {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  color: #666;
  font-size: 0.9rem;
}

.category {
  background: #1890FF;
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

/* 文章摘要 */
.article-summary {
  padding: 2rem;
  background: #f8f9fa;
  border-left: 4px solid #1890FF;
  margin: 2rem;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  font-style: italic;
}

/* 文章正文 */
.article-body {
  padding: 2rem;
  line-height: 1.8;
  color: #333;
}

.article-body h2 {
  color: #1890FF;
  margin: 2rem 0 1rem;
  font-size: 1.5rem;
}

.article-body h3 {
  color: #333;
  margin: 1.5rem 0 1rem;
  font-size: 1.3rem;
}

.article-body p {
  margin-bottom: 1.5rem;
}

.article-body ul,
.article-body ol {
  margin-bottom: 1.5rem;
  padding-left: 2rem;
}

.article-body li {
  margin-bottom: 0.5rem;
}

/* 文章标签 */
.article-tags {
  padding: 2rem;
  border-top: 1px solid #eee;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.tag {
  background: #f0f0f0;
  color: #666;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

/* 分享按钮 */
.article-share {
  padding: 2rem;
  border-top: 1px solid #eee;
  text-align: center;
}

.article-share h4 {
  margin-bottom: 1rem;
  color: #333;
}

.share-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.9rem;
}

.share-btn.wechat {
  background: #07c160;
  color: white;
}

.share-btn.weibo {
  background: #ff8200;
  color: white;
}

.share-btn.qq {
  background: #12b7f5;
  color: white;
}

.share-btn.copy {
  background: #666;
  color: white;
}

.share-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

/* 相关文章 */
.related-articles {
  margin-top: 3rem;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 10px;
}

.related-articles h3 {
  color: #333;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}

.related-grid {
  display: grid;
  gap: 1.5rem;
}

.related-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.3s;
}

.related-card:hover {
  transform: translateY(-3px);
}

.related-image {
  height: 120px;
  background: linear-gradient(45deg, #1890FF, #40a9ff);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
}

.related-content {
  padding: 1.5rem;
}

.related-content h4 {
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.related-summary {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.related-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #999;
}

/* 评论区 */
.comments-section {
  margin-top: 3rem;
  padding: 2rem;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.comments-section h3 {
  color: #333;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}

/* 评论表单 */
.comment-form {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.comment-form h4 {
  color: #333;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1890FF;
}

.btn-submit {
  background: #1890FF;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-submit:hover {
  background: #40a9ff;
  transform: translateY(-2px);
}

/* 评论列表 */
.comments-list {
  margin-top: 2rem;
}

.comment-item {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #eee;
}

.comment-avatar {
  width: 50px;
  height: 50px;
  background: #f0f0f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.comment-content {
  flex: 1;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.comment-name {
  font-weight: 500;
  color: #333;
}

.comment-date {
  color: #999;
  font-size: 0.9rem;
}

.comment-text {
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.comment-actions {
  display: flex;
  gap: 1rem;
}

.action-btn {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 0.9rem;
  transition: color 0.3s;
}

.action-btn:hover {
  color: #1890FF;
}

/* 回复列表 */
.replies {
  margin-top: 1rem;
  padding-left: 1rem;
  border-left: 2px solid #f0f0f0;
}

.reply-item {
  display: flex;
  gap: 0.8rem;
  margin-bottom: 1rem;
}

.reply-avatar {
  width: 35px;
  height: 35px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
}

.reply-content {
  flex: 1;
}

.reply-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.3rem;
}

.reply-name {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.reply-date {
  color: #999;
  font-size: 0.8rem;
}

.reply-text {
  color: #666;
  line-height: 1.5;
  font-size: 0.9rem;
}

/* 底部 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  margin-top: 3rem;
}

.footer .footer-content {
  display: grid;
  grid-template-columns: 0.4fr 0.6fr;
  gap: 3rem;
  margin-bottom: 2rem;
}

.footer .footer-links-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.footer .footer-info h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #fff;
}

.footer .footer-info p {
  margin-bottom: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
}

.footer .contact-info {
  margin-top: 1rem;
}

.footer .contact-info p {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
}

.footer .footer-links, .footer .footer-services, .footer .footer-social {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
  
  .footer .footer-links h4, .footer .footer-services h4, .footer .footer-social h4 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  color: #fff;
  position: relative;
  padding-bottom: 8px;
}

.footer .footer-links h4::after, .footer .footer-services h4::after, .footer .footer-social h4::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background-color: #3498db;
}

.footer .footer-links a, .footer .footer-services a, .footer .footer-social a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.footer .footer-links a:hover, .footer .footer-services a:hover, .footer .footer-social a:hover {
  color: #3498db;
  padding-left: 5px;
}

.footer .social-icons {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.footer .social-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer .footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1rem;
  text-align: center;
}

.footer .copyright {
  opacity: 0.8;
}

.footer .copyright p {
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
  }

  .article-title {
    font-size: 1.8rem;
  }

  .article-meta {
    flex-wrap: wrap;
    gap: 1rem;
  }

  .share-buttons {
    flex-direction: column;
    align-items: center;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>